import { Box, Button, Container, Grid, Typography } from "@mui/material"
import React, { useState, useEffect } from "react";
import styleCss from "../Style/style"
import StrightIcon from "../img/arrow-right-icon.png"
import Travelimg1 from "../img/map1.png"
import Travelimg2 from "../img/map2.png"
import Travelimg3 from "../img/map3.png"
import Travelimg4 from "../img/map4.png"
import StarIcon from "../img/staricon.png"
import ThumbIcon from "../img/thumbicon.png"
import TestiImg from "../img/testimonials.png"
import MobileImgstyle from "../img/mobilebg.png"
import BusSearchBox from "./Bus-search-Section"
import { AuthAxios, NonAuthAxios } from "../Utilities/CommonAxios"
import { useDispatch, useSelector } from "react-redux";


const Home = () => {
    const [popularroutes, setPopularroutes] = useState([]);
    const isAuthenticate = useSelector((state) => state.auth.isAuthenticate)
    const dispatch = useDispatch()
    const fetchpopularroutes = async () => {
        try {
            let apiResponse;
            if (isAuthenticate) {
                apiResponse = await AuthAxios({
                    url: `/popular_routes`,
                    method: "post",
                }, dispatch);

            } else {
                apiResponse = await NonAuthAxios({
                    url: `/popular_routes`,
                    method: "post",
                });
            }
            const popular_route_data = Array.isArray(apiResponse?.data) ? apiResponse.data : [];
            setPopularroutes(popular_route_data);
        } catch (error) {
            setPopularroutes([]);
        }
    };


    useEffect(() => {
        fetchpopularroutes();
    }, []);


    return (
        <>
            <Grid sx={styleCss.BannerTopsection}>
                <Container>
                    <Grid container>
                        <Grid size={{ md: 12 }}>
                            <Typography sx={styleCss.BannerHeading}>
                                Book Your Perfect Bus Journey
                            </Typography>
                            <Typography sx={styleCss.BannerSubtitle}>
                                Safe, comfortable, and affordable bus travel across India. Book now and travel with confidence.
                            </Typography>
                        </Grid>
                    </Grid>
                    <Box sx={styleCss.BannerBoxStyle}>
                        <BusSearchBox />
                        <Grid sx={{ borderBottom: '1px solid #efecec', width: '100%', marginTop: '15px', marginBottom: '10px' }}></Grid>
                        {/* <Grid container spacing={2}>
                            <Grid size={{ md: 12 }}>
                                <Box component="label" sx={{
                                    fontFamily: "Segoe UI",
                                    fontSize: "17px",
                                    fontWeight: 600,
                                    color: "#030213",
                                    textAlign: "left",
                                }}>Popular Routes:</Box>
                            </Grid>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Box sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 1.5,
                                    overflowX: 'visible',
                                    "@media (max-width:600px)": {
                                        display: 'flex',
                                        flexWrap: 'nowrap',
                                        overflowX: 'auto',
                                        gap: 2,
                                        width: '100%',
                                        '& > *': {
                                            flexShrink: 0,
                                            minWidth: 120,
                                        },
                                    },

                                }}>

                                    {popularroutes.length > 0 && (
                                        <Grid container spacing={1}>
                                            {popularroutes.map((route) => (
                                                <Grid item key={route.trip_id}>
                                                    <Button
                                                        variant="contained"
                                                        sx={styleCss.LocationBtnstyle}
                                                    >
                                                        {route.origin_city}
                                                        <img
                                                            src={StrightIcon}
                                                            alt=""
                                                            style={{ marginLeft: "6px", marginRight: "6px" }}
                                                        />
                                                        {route.destination_city}
                                                    </Button>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    )}
                                </Box>
                            </Grid>
                        </Grid> */}
                    </Box>
                </Container>
            </Grid>

            <Grid sx={{ marginTop: '40px' }}>
                <Container>
                    <Grid container>
                        <Grid size={{ md: 12 }}>
                            <Typography sx={styleCss.RedbusStyle}>Why Choose Starbus?</Typography>
                            <Typography sx={styleCss.RedparaStyle}>Trusted by millions of travelers across india</Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
            <Grid sx={{
                marginTop: '40px',
                "@media (max-width:600px)": {
                    marginTop: '10px',
                    marginBottom: '40px',
                },
            }}>
                <Container>
                    <Grid container>
                        <Grid size={{ md: 3, xs: 6 }}>
                            <Typography sx={styleCss.Countnumber}>25M+</Typography>
                            <Typography sx={styleCss.HappyTextstyle}>Happy Customers</Typography>
                        </Grid>
                        <Grid size={{ md: 3, xs: 6 }}>
                            <Typography sx={styleCss.Countnumber}>100k+</Typography>
                            <Typography sx={styleCss.HappyTextstyle}>Bus Routes</Typography>
                        </Grid>
                        <Grid size={{ md: 3, xs: 6 }}>
                            <Typography sx={styleCss.Countnumber}>3K+</Typography>
                            <Typography sx={styleCss.HappyTextstyle}>Bus Partners</Typography>
                        </Grid>
                        <Grid size={{ md: 3, xs: 6 }}>
                            <Typography sx={styleCss.Countnumber}>4.2</Typography>
                            <Typography sx={styleCss.HappyTextstyle}>App Ratings</Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
            <Grid sx={styleCss.TravelCompletstyle}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12 }}>
                            <Typography sx={styleCss.RedbusStyle1}>Travel with Complete Peace of Mind</Typography>
                            <Typography sx={styleCss.RedparaStyle1}>Our Safety + buses ensure your journey is secure and comfortable</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <Grid sx={styleCss.TravelBox}>
                                <img src={Travelimg1} alt="" style={{ width: '100%', overflow: 'hidden' }} />
                                <Grid sx={styleCss.InnerBoxStyle}>
                                    <Typography sx={styleCss.TrackingHead}>Real - time GPS Tracking</Typography>
                                    <Typography sx={styleCss.TrackParastyle}>Track your bus location in real - time throughout your journey</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <Grid sx={styleCss.TravelBox}>
                                <img src={Travelimg2} alt="" style={{ width: '100%', overflow: 'hidden' }} />
                                <Grid sx={styleCss.InnerBoxStyle}>
                                    <Typography sx={styleCss.TrackingHead}>Driver Verification</Typography>
                                    <Typography sx={styleCss.TrackParastyle}>All our drivers undergo through background checks and training</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <Grid sx={styleCss.TravelBox}>
                                <img src={Travelimg3} alt="" style={{ width: '100%', overflow: 'hidden' }} />
                                <Grid sx={styleCss.InnerBoxStyle}>
                                    <Typography sx={styleCss.TrackingHead}>Speed Monitoring</Typography>
                                    <Typography sx={styleCss.TrackParastyle}>Continuous monitoring ensures buses maintain safe speeds</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <Grid sx={styleCss.TravelBox}>
                                <img src={Travelimg4} alt="" style={{ width: '100%', overflow: 'hidden' }} />
                                <Grid sx={styleCss.InnerBoxStyle}>
                                    <Typography sx={styleCss.TrackingHead}>24/7 Support</Typography>
                                    <Typography sx={styleCss.TrackParastyle}>Round-the-clock customer support for any assistance</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
            <Grid sx={{ paddingTop: '10px', paddingBottom: '60px' }}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12 }}>
                            <Typography sx={styleCss.RedbusStyle}>Exclusive Offers & Deals</Typography>
                            <Typography sx={styleCss.RedparaStyle}>Save more on your bus bookings with our special promotions</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '40px' }}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Grid sx={styleCss.BookingBox}>
                                <Grid container>
                                    <Grid size={{ md: 12, xs: 12 }}>
                                        <Typography sx={styleCss.FirstStyle}>First Time User Offer</Typography>
                                        <Typography sx={styleCss.DiscoundStyle}>Special discount for new users</Typography>
                                    </Grid>
                                    <Grid size={{ md: 8, xs: 12 }}>
                                        <Typography sx={styleCss.FirstStyle}>Save upto $250</Typography>
                                        <Typography sx={styleCss.CodeStyle}>Use Code: FIRST250</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Grid sx={styleCss.BookingBox1}>
                                <Grid container>
                                    <Grid size={{ md: 12, xs: 12 }}>
                                        <Typography sx={styleCss.FirstStyle}>Super Premium</Typography>
                                        <Typography sx={styleCss.DiscoundStyle2}>Luxury Bus booking</Typography>
                                    </Grid>
                                    <Grid size={{ md: 8, xs: 12 }}>
                                        <Typography sx={styleCss.FirstStyle}>Save upto $250</Typography>
                                        <Typography sx={styleCss.CodeStyle1}>Use Code: Premium300</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Grid sx={styleCss.BookingBox2}>
                                <Grid container>
                                    <Grid size={{ md: 12, xs: 12 }}>
                                        <Typography sx={styleCss.FirstStyle}>Bus & Hotel</Typography>
                                        <Typography sx={styleCss.DiscoundStyle3}>Complete travel package</Typography>
                                    </Grid>
                                    <Grid size={{ md: 8, xs: 12 }}>
                                        <Typography sx={styleCss.FirstStyle}>Save upto $250</Typography>
                                        <Typography sx={styleCss.CodeStyle2}>Use Code: Premium300</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
            <Grid sx={{
                paddingTop: '50px', paddingBottom: '60px', "@media (max-width:600px)": {
                    paddingTop: '10px', paddingBottom: '0px',
                },
            }}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Typography sx={styleCss.WhatStyle}>
                                What Our
                                Customers Say
                            </Typography>
                            <Typography sx={styleCss.StoriesStyle}>
                                Real stories from real travelers
                            </Typography>
                        </Grid>
                        <Grid size={{ md: 8, xs: 12 }}>
                            <Grid container spacing={2}>
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <Box sx={styleCss.TestmonailsBox}>
                                        <Grid sx={{ padding: '20px 10px' }}>
                                            <Grid sx={{
                                                display: 'flex', justifyContent: 'center',
                                                "@media (max-width:600px)": {
                                                    justifyContent: 'left'
                                                },
                                            }}>
                                                <Grid sx={{ marginRight: '10px' }}>
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                </Grid>
                                                <Grid>
                                                    <Typography sx={styleCss.TestimonialsStyle}>
                                                        <img src={ThumbIcon} alt="" style={{ verticalAlign: 'middle' }} /> Testimonial
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }}>
                                                <Typography sx={styleCss.FeatureStyle}>“The safety + feature gave me peace of mind during my night journey, Excellent Service!</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid sx={styleCss.TestimonailsFooter}>
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid sx={{ marginRight: '10px', }}>
                                                    <img src={TestiImg} alt="" />
                                                </Grid>
                                                <Grid>
                                                    <Typography sx={styleCss.Namestyle}>
                                                        Kristin Watson
                                                    </Typography>
                                                    <Typography sx={styleCss.Subtitle}>
                                                        Kristin Watson
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <Box sx={styleCss.TestmonailsBox}>
                                        <Grid sx={{ padding: '20px 10px' }}>
                                            <Grid sx={{
                                                display: 'flex', justifyContent: 'center', "@media (max-width:600px)": {
                                                    justifyContent: 'left'
                                                },
                                            }}>
                                                <Grid sx={{ marginRight: '10px' }}>
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                </Grid>
                                                <Grid>
                                                    <Typography sx={styleCss.TestimonialsStyle}>
                                                        <img src={ThumbIcon} alt="" style={{ verticalAlign: 'middle' }} /> Testimonial
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }}>
                                                <Typography sx={styleCss.FeatureStyle}>“The safety + feature gave me peace of mind during my night journey, Excellent Service!</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid sx={styleCss.TestimonailsFooter}>
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid sx={{ marginRight: '10px', }}>
                                                    <img src={TestiImg} alt="" />
                                                </Grid>
                                                <Grid>
                                                    <Typography sx={styleCss.Namestyle}>
                                                        Kristin Watson
                                                    </Typography>
                                                    <Typography sx={styleCss.Subtitle}>
                                                        Kristin Watson
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <Box sx={styleCss.TestmonailsBox}>
                                        <Grid sx={{ padding: '20px 10px' }}>
                                            <Grid sx={{
                                                display: 'flex', justifyContent: 'center', "@media (max-width:600px)": {
                                                    justifyContent: 'left'
                                                },
                                            }}>
                                                <Grid sx={{ marginRight: '10px' }}>
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                    <img src={StarIcon} alt="" />
                                                </Grid>
                                                <Grid>
                                                    <Typography sx={styleCss.TestimonialsStyle}>
                                                        <img src={ThumbIcon} alt="" style={{ verticalAlign: 'middle' }} /> Testimonial
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }}>
                                                <Typography sx={styleCss.FeatureStyle}>“The safety + feature gave me peace of mind during my night journey, Excellent Service!</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid sx={styleCss.TestimonailsFooter}>
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid sx={{ marginRight: '10px', }}>
                                                    <img src={TestiImg} alt="" />
                                                </Grid>
                                                <Grid>
                                                    <Typography sx={styleCss.Namestyle}>
                                                        Kristin Watson
                                                    </Typography>
                                                    <Typography sx={styleCss.Subtitle}>
                                                        Kristin Watson
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
            <Grid sx={styleCss.DownloadStyle}>
                <Container>
                    <Grid container spacing={2} alignItems="center">
                        <Grid size={{ md: 8, xs: 12 }}>
                            <Typography sx={styleCss.DownloadHead}>Download StarBus App</Typography>
                            <Typography sx={styleCss.ExclusiveStyle}>Get exclusive app-only deals and faster booking experience</Typography>
                            <Button variant="contained" sx={{
                                padding: '13px 14px',
                                borderRadius: '7px',
                                backgroundColor: '#fdfdff',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                color: '#ff5714',
                                textTransform: 'capitalize',
                                marginTop: '10px',
                            }}>Download App</Button>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }} sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Box component="img" src={MobileImgstyle} alt="" sx={{
                                width: '320px', marginTop: '-77px', "@media (max-width:600px)": {
                                    display: 'none'
                                },
                            }} />
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
        </>
    )
}

export default Home